import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
  Separator,
} from '@bechtel/gds';
import { t, Trans } from '@lingui/macro';
import { PinCostCodesError, UnpinCostCodesError } from '@bechtel/types';
import { useName } from '@bechtel/client-common';
import { find, map } from 'lodash';
import { ApolloError } from '@apollo/client';

interface PinUnpinErrorProps {
  error: PinCostCodesError | UnpinCostCodesError | ApolloError;
  close: () => void;
}

const getErrorMessage = (error: PinUnpinErrorProps['error']) => {
  if (error instanceof ApolloError)
    return (
      <Trans>
        Network error has occured.Please press the &ldquo;Retry&rdquo; button to fetch the latest data and try again.
      </Trans>
    );
  switch (error) {
    case PinCostCodesError.COST_CODE_ALREADY_PINNED:
      return <Trans>Cost Code already pinned.</Trans>;
    case PinCostCodesError.INVALID_COST_CODE:
      return <Trans>Invalid Cost Code pinned.</Trans>;
    case PinCostCodesError.INVALID_WORK_PACKAGE_ID:
      return <Trans>Invalid Work Package pinned.</Trans>;
    case PinCostCodesError.SERVICE_PROXY_ERROR:
      return <Trans>Server Proxy Error.</Trans>;
    case UnpinCostCodesError.INVALID_COST_CODES:
      return <Trans>Invalid Cost Code Unpinned.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const PinUnpinError: FC<PinUnpinErrorProps> = ({ error, close }) => {
  const { getFullName } = useName();
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '450px', maxHeight: '450px' }}>
      <ModalHeader title={t`Pin/Unpin Cost Code Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box px={{ sm: '500' }} py={{ sm: '700' }}>
          <Text size="600">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
